var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{staticClass:"p-switch p-fill",class:_vm.size,on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }